export default __webpack_public_path__ + "static/char-s-37-ja-bf97e952707298c8c1321ef3829530f2.webp";